export default __webpack_public_path__ + "static/media/skirmishers_greatbow.63d4bc75.jpg";